/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/Dashboard.js";
import Explore from "views/Explore.js";
import Icons from "views/Icons.js";
import Map from "views/Map.js";
import Notifications from "views/Notifications.js";
import ProjectInfo from "views/ProjectInfo";
import Rtl from "views/Rtl.js";
import TableList from "views/TableList.js";
import Typography from "views/Typography.js";
import UserProfile from "views/UserProfile.js";
import UserView from "views/UserView.js";
import Settings from "views/Settings.js";
import ListView from "views/ListView";
import Feedback from "views/Feedback.js";
import Learn from "views/Learn.js";
import StudioPage from "views/Studio/StudioPage.js";
import ConfigManager from "views/ConfigManager/ConfigManager.js";

var routes = [
  /*{
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-chart-pie-36",
    component: Dashboard,
    layout: "",
  },*/
  {
    path: "/explore",
    name: "Explore",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-compass-05",
    component: Explore,
    layout: "",
  },
  {
    path: "/user-view",
    name: "My Projects",
    rtlName: "ملف تعريفي للمستخدم",
    icon: "tim-icons icon-notes",
    component: UserView,
    layout: "",
  },
  // {
  //   path: "/studio",
  //   name: "Studio",
  //   rtlName: "الاستوديو",
  //   icon: "tim-icons icon-components",
  //   component: "",
  //   layout: "",
  // },
  {
    path: "/studio-re/:projectCode",
    name: "Studio (React)",
    rtlName: "الاستوديو",
    icon: "tim-icons icon-laptop",
    component: StudioPage,
    layout: "",
    hideInSidebar: true, // Don't show in navigation menu
  },
  {
    path: "/learn",
    name: "Learn",
    rtlName: "ملف تعريفي للمستخدم",
    icon: "tim-icons icon-pencil",
    component: Learn,
    layout: "",
  },
  {
    path: "/user-profile",
    name: "User Profile",
    rtlName: "ملف تعريفي للمستخدم",
    icon: "tim-icons icon-single-02",
    component: UserProfile,
    layout: "",
  },
  {
    path: "/project-info",
    name: "Project Info",
    rtlName: "بيانات المشروع",
    icon: "tim-icons icon-notes",
    component: ProjectInfo,
    layout: "",
  },
  {
    path: "/settings",
    name: "Settings",
    rtlName: "ملف تعريفي للمستخدم",
    icon: "tim-icons icon-settings-gear-63",
    component: Settings,
    layout: "",
  },
  {
    path: "/admin/config-manager",
    name: "Config Manager",
    rtlName: "إدارة التكوين",
    icon: "tim-icons icon-settings",
    component: ConfigManager,
    layout: "",
  },
  {
    path: "/list-view",
    name: "List View",
    rtlName: "قائمة",
    icon: "tim-icons icon-notes",
    component: ListView,
    layout: "",
  },
  {
    path: "/feedback",
    name: "Feedback",
    rtlName: "قائمة",
    icon: "fa fa-question-circle",
    component: Feedback,
    layout: "",
  },
];
export default routes;
